module.exports = __webpack_public_path__ + "img/icon-file-upload.e23f874e.svg";